import { info } from 'autoprefixer'
import { fromEvent } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

const limit = (number, min, max) => {
  if (number > max) {
    return max
  }
  if (number < min) {
    return min
  }
  return number
}

const QUERIES = [
  '[data-logo-interfere-class]',
  '[data-logo-interfere-class-rich-text] li',
  '[data-logo-interfere-class-rich-text] p',
  '[data-logo-interfere-class-rich-text] blockquote',
  '[data-logo-interfere-class-rich-text] hr',
  '[data-logo-interfere-class-rich-text] br',
  '[data-logo-interfere-class-rich-text] h1',
  '[data-logo-interfere-class-rich-text] h2',
  '[data-logo-interfere-class-rich-text] h3',
  '[data-logo-interfere-class-rich-text] h4',
  '[data-logo-interfere-class-rich-text] h5',
  '[data-logo-interfere-class-rich-text] h6',
  '[data-logo-interfere-class-rich-text] h5',
  '[data-logo-interfere-class-rich-text] dt',
  '[data-logo-interfere-class-rich-text] dd',
  '[data-logo-interfere-class-rich-text] figcaption'
]
const INTERSECTING_CLASS = 'intersecting-with-logo'
export default class LogoInterferenceController {
  constructor () {
    this._initIntersectionObserver()
    // this.updateRegisteredElements()
    this._bindUIActions()
  }

  _findTrackedElements () {
    return QUERIES.flatMap((query) => Array.from(document.querySelectorAll(query)))
  }

  _initIntersectionObserver () {
    if (this.observer) {
      this.observer.disconnect()
    }
    const trackedElements = this._findTrackedElements()
    this._visibleElements = new Set()
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            this._visibleElements.add(e.target)
          } else {
            this._visibleElements.delete(e.target)
          }
        })
      },
      {
        root: null,
        threshold: 0
      }
    )
    trackedElements.forEach(element => {
      this.observer.observe(element)
    })
  }

  _updateFadeLimits () {
    const logoBox = document.querySelector('.desktop-header__logo-container')
    if (logoBox) {
      const logoHeight = logoBox.getBoundingClientRect().height
      const logoPaddingBottom = 50
      this._logoFound = true
      this._fadeTopY = logoHeight - logoPaddingBottom
      this._fadeLength = logoPaddingBottom
    } else {
      this._logoFound = false
    }
  }

  _updateElements () {
    this._visibleElements.forEach(element => {
      const elementRect = element.getBoundingClientRect()
      const elementTopY = elementRect.top
      const relativeY = elementTopY - this._fadeTopY
      const fadeFactor = limit(relativeY / this._fadeLength, 0, 1)
      const opacity = fadeFactor
      element.style.opacity = opacity
    })
  }

  _bindUIActions () {
    this._updateFadeLimits()
    const resize$ = fromEvent(window, 'resize').pipe(
      debounceTime(200)
    )
    resize$.subscribe(() => {
      this._updateFadeLimits()
      this._updateElements()
    })

    const scroll$ = fromEvent(window, 'scroll')

    scroll$.subscribe(e => {
      if (!this._logoFound) {
        this._updateFadeLimits()
      }
      this._updateElements()
    })
  }
}
